export class UnknownApiError extends Error {
  constructor(message: string = 'An unknown error occurred.') {
    super(message)
    Object.setPrototypeOf(this, UnknownApiError.prototype)
  }
}
